const data = {
	"body": "<path fill=\"currentColor\" d=\"M10 19a1 1 0 0 1-.64-.23a1 1 0 0 1-.13-1.41L13.71 12L9.39 6.63a1 1 0 0 1 .15-1.41a1 1 0 0 1 1.46.15l4.83 6a1 1 0 0 1 0 1.27l-5 6A1 1 0 0 1 10 19Z\"/>",
	"width": 24,
	"height": 24
};
exports.__esModule = true;
exports.default = data;
